import React from "react";

const Loader = () => {
  return (
    <div className="parent">
      <div className="loader"></div>
    </div>
  );
};

export default Loader;
